import script from "./BaseSupport.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSupport.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSupport.vue?vue&type=style&index=0&id=c04ab756&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c04ab756"]])

export default __exports__